import { createAction, props } from '@ngrx/store';

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record payment arrangement',
    props<{dossierId: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record payment arrangement success', 
    props<{ singleData: any }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record payment arrangement failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state payment arrangement',
);